export const ACCESS_TOKEN_NAME = 'accessToken';
export const CURRENT_USER_IN_LOCKAL_STORAGE = 'currentUser';
